import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { HelpdeskTaskPriorityEnum } from '@zaoblako/shared/modules/helpdesk/enum/helpdesk.task.priority.enum';
import { HelpdeskPriorityI18nEnum } from '@zaoblako/shared/modules/helpdesk/i18n/helpdesk.priority.i18n.enum';

@Pipe({
  name: 'helpdeskTaskPriorityName',
  standalone: true
})
export class HelpdeskTaskPriorityNamePipe implements PipeTransform {
  public transform(priority: HelpdeskTaskPriorityEnum): string {
    return HelpdeskPriorityI18nEnum[I18nLocalesEnum.RU_RU][priority] || '';
  }
}
